/*
    Хедер
*/

import * as LockScroll from './LockScroll.js';
import { debounce } from './ThrottleDebounce';

const $menuBurger = $('.js-menu-burger');
const $menuClose = $('.js-menu-close');
const $mainMenu = $('.js-main-menu');
const $submenuItems = $mainMenu.find('._submenu > a');
const $submenuWraps = $mainMenu.find('.submenu-wrap');

const debounceScroll = debounce(() => {
    if (App.W.scrollTop() > 100) {
        App.H.addClass('_hide-logo');
    } else {
        App.H.removeClass('_hide-logo');
    }
}, 100);

App.W.on('scroll', () => {
    debounceScroll();
});


/* Открытие главного меню */
$menuBurger.on('click', function () {
    $mainMenu.addClass('_open');
    LockScroll.lock();
});


/* Закрытие главного меню */
$menuClose.on('click', function () {
    $mainMenu.removeClass('_open');
    LockScroll.unlock();
});


/* Открытие подменю главного меню на мобиле */
$submenuItems.on('click', function (e) {
    if (App.mobile) {
        e.preventDefault();

        const $currLink = $(this);
        const windowWidth = App.W.outerWidth();

        //if (windowWidth <= App.tabletV) {
        if (windowWidth < App.tabletH) {
            $currLink.toggleClass('_open');
            $currLink.siblings('.submenu-wrap').stop().slideToggle();
        } else {
            $submenuItems.removeClass('_open');
            $currLink.addClass('_open');
        }
    }
});


/* Закрываем главное меню по клику на пустое место */
App.D.on('mouseup', function(e) {
    if (!$mainMenu.is(e.target) && $mainMenu.has(e.target).length === 0 && $mainMenu.hasClass('_open')) {
        $menuClose.trigger('click');
    }

    if (!$submenuWraps.is(e.target) && $submenuWraps.has(e.target).length === 0) {
        const windowWidth = App.W.outerWidth();

        if (windowWidth > App.tabletV) {
            $submenuItems.removeClass('_open');
        }
    }
});


// WEBPACK FOOTER //
// ./_src/js/modules/Header.js